var request = require('./request.js')

// 登录相关API
var loginApi = {
	// 用户登录
	userLogin: function (data) {
		return request.post('/api/login', data)
	},
}

//借用相关API
var borrowApi = {
	// 箱格列表
	boxLists: function (data) {
		return request.post('/api/boxLists', data)
	},
	// 获取箱格号
	scanOpenBox: function (data) {
		return request.post('/api/scanOpenBox', data)
	},
	allInventory: function (data) {
		return request.post('/api/allInventory', data)
	},
}

//管理员相关API
var adminApi = {
	// 箱格列表
	boxLists: function (data) {
		return request.post('/api/boxLists', data)
	},
	// 员工列表
	getUserLists: function (data) {
		return request.post('/api/getUsers', data)
	},
	// 员工特征数据修改
	updateUser: function (data) {
		return request.post('/api/updateUser', data)
	},
	// 获取员工数据
	getCharacteristic: function (data) {
		return request.post('/api/getCharacteristic', data)
	},
	// 盘点
	borrowReturn: function (data) {
		return request.post('/api/borrowReturn', data)
	},
}

//出入库相关API
var wareApi = {
	// 获取产品
	getProductRfid: function (data) {
		return request.post('/api/getProductByRfid', data)
	},
	// 出库
	outStorage: function (data) {
		return request.post('/api/outStorage', data)
	},
	// 入库
	inStorage: function (data) {
		return request.post('/api/inStorage', data)
	},
	// 获取大屏库存列表
	showProduct: function (data) {
		return request.post('/api/showProduct', data)
	},
	// 出入库盘点
	medicalAct: function (data) {
		return request.post('/api/medicalAct', data)
	},
	// 复核列表
	medicalReview: function (data) {
		return request.post('/api/medicalReview', data)
	},
	// 复核列表
	updateReview: function (data) {
		return request.post('/api/updateReview', data)
	},

	//开锁/获取所有锁状态
	ylcbdh:function(data){
		return request.post2('/cgi-bin/cell.cgi',data)
	},
	//同步数据
	syncMenber:function(data){
		return request.post2('/dlfg',data)
	},
}

//寄存柜二维码接口
var lockerApi = {
	getQrCode:function(data){
		return request.post('/Web/Flat/getComTacByDevice', data)
	},
	previewImg:function(data){
		return request.post('/Common/Qrcode/createQrCodeImage', data)
	}
}

//钥匙柜相关API
var keyCabinetApi = {
	//获取锁列表
	getList:function(data){
		return request.post('/api/getKeyBoxList',data)
	},
	//开锁/获取所有锁状态
	openKey:function(data){
		return request.post2('/cgi-bin/cell.cgi',data)
	},
}

// 公共API
var commonApi = {
	// 获取广告列表
	getAdsList: function (data) {
		return request.post('/web/common/getCompanyAds', data)
	},
	// 获取客服热线信息
	getHotline: function (data) {
		return request.post('/web/common/getHotlineInfo', data)
	},
}


export {
	loginApi,
	borrowApi,
	adminApi,
	wareApi,
	lockerApi,
	keyCabinetApi,
	commonApi
}



//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = null
// module chunks = 